import DatabaseModel from './DatabaseModel.js';

var GeoUtils = Object.create(DatabaseModel);

GeoUtils.model = 'geo';

GeoUtils.geocodificarLote = function(params = {}) {
  var self = this;
  const direcciones = params.direcciones || [];

  const requestParams = {
    url: self.server_movilidad + self.prefix + 'geo/lote',
    method: 'POST',
    data: direcciones
  };

  return self.sendRequest(requestParams, false).then(res => {
    if (Array.isArray(res)) {
      return res;
    }
    if (res && Array.isArray(res.list)) {
      return res.list;
    }
    return [];
  });
};

export default GeoUtils;
